var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"copyright"},[_c('div',{staticClass:"text"},[_vm._v("\n    确认患者行程数据由 \n  ")]),_vm._v(" "),_c('img',{staticClass:"logo",attrs:{"src":_vm.imageMap.logo,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"text"},[_vm._v("\n     整理提供\n  ")])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77771bca","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/projects/virusTrip/pages/searchResult/copyright.vue
// module id = null
// module chunks = 